<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="600"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center mt-1">
      <SysCompradorAutocomplete
        v-model="filtros.compradores"
        label="Comprador"
        outlined
        hide-details
        multiple
        :qtde_visivel_selecionados="1"
      />
    </div>

    <div class="d-flex align-center mt-1">
      <SysSegmentoAutocomplete
        v-model="filtros.segmentos"
        label="Segmentos"
        outlined
        multiple
        hide-details
        class="mt-4"
      />
    </div>
  </SysDialog>
</template>

<script>
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import Mixin from "@/components/Relatorios/Mixin";
import $axios from "@/api/api";

export default {
  name: "RelatorioAvariaProdutosFilialPorData",
  mixins: [Mixin],
  components: {
    SysCompradorAutocomplete,
    SysSegmentoAutocomplete
  },
  data: () => ({
    filtros: {
      compradores: [],
      segmentos: []
    },
  }),
  methods: {
    gerarRelatorio() {
      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");

      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
